<template>
  <div class="app-card-member">
    <div class="app-card-member__inner">
      <div class="app-card-member__logo">
        <img :src="data.logoLink" alt="logo" v-if="data.logoLink">
      </div>
      <div class="app-card-member__details">
        <div class="app-card-member__title"
             v-if="data.title" @click="$emit('member-open', data.id)">{{ data.title }}</div>
        <div class="app-card-member__description"
             v-if="data.description">{{ data.description }}</div>
      </div>
    </div>
    <div class="app-card-member__favorites" :class="data.favorites ? 'is-active' : ''"
         @click="$emit('favorites', data.id)">
      <span v-if="!data.favorites">{{ data.outFavorites }}</span>
      <span v-if="data.favorites">{{ data.inFavorites }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCardMember',
  props: ['data'],
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  @import "app-card-member";
</style>
